import React, { useEffect, useState } from 'react';
import './App.css';
import { Bouncer } from './Bouncer';
import { BInstrument, instr, start } from './instrument';

function App() {

  const [started, setStarted] = useState(false);

  const [instrument, setInstrument] = useState(undefined as undefined | BInstrument);

  useEffect(() => {
    const ins = instr(() => {
      setInstrument(ins);
    });
  }, [])


  return (
    <div className="App wrapper">
      {!instrument && <div style={{ fontSize: 20, color: "#eee" }}>Loading...</div>}
      {!!instrument && !started &&
        <div className="">
          <button type="button" onClick={() => {
            setStarted(true);
            start();
          }}>START</button>
        </div>
      }
      {started && !!instrument &&
        <Bouncer instrument={instrument} />
      }
      {/* <div style={{ position: "fixed", fontSize: 40, color: "#eee" }} id="aa"></div> */}
    </div>
  );
}

export default App;
